<template>
  <div class="main">
    <div class="nav">
      <div class="center">
        <img src="./images/logo.png">
        <ul>
          <li @click="scrollToSection('section1')">首页</li>
          <li @click="scrollToSection('section2')">服务项目</li>
          <li @click="scrollToSection('section3')">案例展示</li>
          <li @click="scrollToSection('section4')">联系我们</li>
          <li @click="scrollToSection('section5')">关于我们</li>
          <!-- <li @click="scrollToSection('section5')">联系我们</li> -->
        </ul>
      </div>
    </div>
    <div class="banner" ref="section1">
      <img src="./images/banner.png">
      <!-- <div class="right">
        <span style="font-size: 44px;">智慧仓储</span>
        <span style="font-size: 44px;font-weight: bold;">重塑仓储管理新标杆</span>
        <span style="font-size: 18px;color: #000;font-weight: bold;">精准出入库审批，实时库存告警，打造高效仓储管理体系</span>
        <div class="btn">免费试用</div>
      </div> -->
    </div>
    <div class="solve" ref="section2">
      <div class="center">
        <div class="title">服务项目</div>
        <div class="article">
          <div class="square1">
            <img class="logo1" src="./images/logo1-2.png">
            <div class="squareTitle">
              网站制作
            </div>
            <div class="content">
              智慧仓储平台构建标准化出入库审批流程，线上提交申请，审批进度实时跟踪。通过智能提醒和权限管理，确保审批高效进行，避免人为延误，提升仓储作业流转速度。
            </div>
          </div>
          <div class="square2">
            <img class="logo2" src="./images/logo2-2.png">
            <div class="squareTitle">
              后台管理系统
            </div>
            <div class="content">
              平台与各类仓储设备实时数据对接，自动更新库存信息。结合库存告警功能，设置阈值，一旦库存异常，立即通过多种渠道（如短信、系统通知）通知相关人员，让您随时把控库存动态。
            </div>
          </div>
          <div class="square3">
            <img class="logo3" src="./images/logo3-2.png">
            <div class="img"></div>
            <div class="squareTitle">
              可视化大屏
            </div>
            <div class="content">
              利用大数据分析和智能算法，智慧仓储平台对历史数据和实时数据深度挖掘，精准预测库存需求。配合库存告警和灵活的出入库审批，帮助您优化库存结构，减少积压，避免缺货，降低库存成本。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ability">
      <div class="center">
        <div class="title">网站制作</div>
        <div class="English">WEBSITE DEVELOPMENT</div>
        <div class="article">
          <div class="left">
            <img src="./images/website1.png" style="width: 100%;height: 100%;">
          </div>
          <div class="right">
            <div class="title">专业设计团队</div>
            <div class="content">
              我们的设计团队成员拥有丰富的品牌设计经验。他们不仅精通设计美学，更深入理解不同行业的品牌内涵，能够精准把握您的品牌理念，将其巧妙融入网站界面设计，打造出独一无二、极具辨识度的品牌数字形象。
            </div>
          </div>
        </div>
        <div class="article">
          <div class="right">
            <div class="title" style="text-align: right;">前沿技术运用</div>
            <div class="content">
              紧跟技术发展趋势，采用最新的网页开发框架与技术，如 React、Vue
              等，确保网站具备卓越的性能。我们注重代码的优化，实现快速加载，大幅提升用户访问速度，降低跳出率。同时，响应式设计技术让网站在电脑、平板、手机等各类设备上均能完美适配，为用户带来无缝的浏览体验。
            </div>
          </div>
          <div class="left">
            <img src="./images/website1.png" style="width: 100%;height: 100%;">
          </div>
        </div>
        <div class="article">
          <div class="left">
            <img src="./images/website1.png" style="width: 100%;height: 100%;">
          </div>
          <div class="right">
            <div class="title">深度定制化服务</div>
            <div class="content">
              摒弃模板化设计，针对每个项目进行深入调研与分析。从网站的功能架构到页面布局，再到交互细节，都根据您的业务需求和目标受众特点进行定制。无论是企业官网的信息展示逻辑，还是电商平台的购物流程优化，我们都能提供个性化解决方案，满足您的特定需求。
            </div>
          </div>
        </div>
        <div class="article" style="height: 530px;">
          <div class="case" style="margin-right: 20px;">
            <img src="./images/case1.png" style="width: 100%;">
            <span
              style="font-size: 22px;font-weight: bold;text-align: left;display: block;width: 100%;line-height: 40px;">智呈可视化工具平台</span>
            <span style="text-align: left;display: block;color: #666;line-height: 24px;">金融业、制造业、政府部门等</span>
            <span
              style="text-align: left;display: block;color: #666;line-height: 24px;">专注于数据可视化和智能呈现，利用软件技术将各种数据转化为直观的可视化图表、图形和界面，帮助用户更好地理解和分析数据。</span>
            <div class="btn" @click="trial1()">
              免费试用
            </div>
          </div>
          <div class="case" style="margin-left: 20px;">
            <img src="./images/case1.png" style="width: 100%;">
            <span
              style="font-size: 22px;font-weight: bold;text-align: left;display: block;width: 100%;line-height: 40px;">智步云上技术分享社区</span>
            <span style="text-align: left;display: block;color: #666;line-height: 24px;">技术爱好者、公司内部等</span>
            <span
              style="text-align: left;display: block;color: #666;line-height: 24px;">通过发布文章、帖子、代码示例、视频教程等多种形式，分享自己在技术学习、实践过程中的经验、心得、成果以及遇到的问题和解决方案。</span>
            <div class="btn" @click="trial2()">
              免费试用
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="business">
      <div class="center">
        <div class="title">后台管理系统</div>
        <div class="English">BACKEND SYSTEM</div>
        <div class="article">
          <div class="square">
            <div class="title">
              贴合业务逻辑定制
            </div>
            <div class="content">
              在项目启动前，我们的团队会深入企业内部，详细了解您的业务流程、组织架构以及管理需求。以此为基础，定制开发完全贴合企业运营逻辑的后台管理系统，确保系统中的每一个功能模块都能精准服务于日常业务，提升工作效率与协同效果。
            </div>
          </div>
          <div class="square">
            <div class="title">
              强大的系统整合能力
            </div>
            <div class="content">
              我们的后台管理系统具备出色的兼容性，能够与企业现有的各类软件、工具进行无缝对接，如 ERP、CRM
              等。实现数据的实时共享与交互，打破信息孤岛，让企业运营更加顺畅高效。同时，支持多数据源接入，方便对不同来源的数据进行统一管理与分析。
            </div>
          </div>
          <div class="square">
            <div class="title">
              安全可靠的架构
            </div>
            <div class="content">
              深知数据安全对企业的重要性，我们采用多层安全防护架构，从网络层、系统层到应用层，全方位保障数据安全。数据加密技术确保数据在传输与存储过程中的保密性，严格的用户权限管理机制防止数据泄露，定期的系统漏洞扫描与修复，为企业数据保驾护航。
            </div>
          </div>
        </div>
        <div class="article" style="height: 530px;">
          <div class="case" style="margin-right: 20px;">
            <img src="./images/case1.png" style="width: 100%;">
            <span
              style="font-size: 22px;font-weight: bold;text-align: left;display: block;width: 100%;line-height: 40px;">三防数据采集平台</span>
            <span style="text-align: left;display: block;color: #666;line-height: 24px;">文物保护单位、博物馆等</span>
            <span
              style="text-align: left;display: block;color: #666;line-height: 24px;">将分布在不同区域的文物保护单位、博物馆等场所的三防相关设备进行连接，实时采集各类数据，并上传至中心数据库进行存储、处理和分析。</span>
            <div class="btn" @click="scrollToSection('section4')">
              付费试用
            </div>
          </div>
          <div class="case" style="margin-left: 20px;">
            <img src="./images/case1.png" style="width: 100%;">
            <span
              style="font-size: 22px;font-weight: bold;text-align: left;display: block;width: 100%;line-height: 40px;">智慧仓储管理系统</span>
            <span style="text-align: left;display: block;color: #666;line-height: 24px;">物流与供应链、工业互联网、智能制造行业等</span>
            <span
              style="text-align: left;display: block;color: #666;line-height: 24px;">借助物联网、大数据、人工智能、自动化设备等先进技术构建的综合性管理系统，用于对仓储运作的全流程进行智能化管理与控制。</span>
            <div class="btn" @click="scrollToSection('section4')">
              付费试用
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="partner">
      <div class="center">
        <div class="title">可视化大屏</div>
        <div class="English">VISUAL SCREEN</div>
        <div class="article">
          <div class="square">
            <img src="./images/logo4.png">
            <div class="squareTitle">
              专业的数据可视化设计
            </div>
            <div class="content">
              团队中的数据可视化专家，擅长将复杂的数据转化为直观、美观的可视化图表与图形。他们依据数据特点和业务需求，精心设计大屏布局，选择最合适的可视化元素，如柱状图、折线图、地图等，让数据信息一目了然，帮助您快速做出决策。
            </div>
          </div>
          <div class="square">
            <img src="./images/logo5.png">
            <div class="squareTitle">
              实时数据更新与交互
            </div>
            <div class="content">
              可视化大屏与企业数据系统实时连接，数据动态更新，确保您看到的始终是最新的业务数据。同时，支持交互操作，用户可以通过点击、缩放等操作深入探索数据细节，挖掘更多有价值的信息，满足不同场景下的数据分析需求。
            </div>
          </div>
          <div class="square">
            <img src="./images/logo6.png">
            <div class="squareTitle">
              多场景应用定制
            </div>
            <div class="content">
              无论是企业的运营监控中心、指挥调度室，还是对外展示的展厅，我们都能根据场景特点进行定制化设计。从屏幕尺寸、分辨率到展示内容的侧重点，都进行针对性优化，让可视化大屏在不同场景下都能发挥最大价值，为企业提升形象、辅助决策提供有力支持。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="show" ref="section3">
      <div class="center">
        <div class="title">案例展示</div>
        <div class="screen">
          <div class="left">
            <img src="./images/screen1.png">
          </div>
          <div class="right">
            <span
              style="display:block;font-size: 22px;font-weight: bold;text-align: left;line-height: 40px;">智慧军营</span>
            <span
              style="display:block;font-weight: bold;text-align: left;line-height: 40px;font-size: 18px;color: #999;">河南某军营</span>
            <span
              style="display:block;font-weight: normal;text-align: left;color: #666;line-height: 24px;">智慧军营可视化整合了物联网、大数据、人工智能、地理信息系统（GIS）以及虚拟现实（VR）/
              增强现实（AR）等前沿技术。借助物联网，各类设备与设施实现互联互通，实时采集人员、装备、环境等多维度数据；大数据技术对海量数据进行存储、清洗与分析挖掘，为可视化呈现提供精准数据支撑；人工智能用于智能识别与预测分析，例如人员行为分析、设备故障预警等；GIS
              能直观展示军营地理空间布局及资产分布；VR/AR 技术则为特定场景带来沉浸式体验，如虚拟训练场景构建。</span>
            <div class="btn" @click="detail1()">
              查看详情
            </div>
          </div>
        </div>
        <div class="screen">
          <div class="left">
            <img src="./images/screen2.png">
          </div>
          <div class="right">
            <span
              style="display:block;font-size: 22px;font-weight: bold;text-align: left;line-height: 40px;">数字孪生高速</span>
            <span
              style="display:block;font-weight: bold;text-align: left;line-height: 40px;font-size: 18px;color: #999;">国内某高速</span>
            <span style="display:block;font-weight: normal;text-align: left;color: #666;line-height: 24px;">数字孪生高速基于
              BIM、GIS
              等技术构建高速公路的三维数字模型，实现道路、桥梁、隧道、收费站等设施的可视化展示，并将实时数据与模型相结合，让管理者能直观了解高速公路的运行状态。通过将真实世界中的高速公路系统进行数字化建模，利用物理模型、传感器数据、运行历史等信息，集成多学科、多物理量、多尺度、多概率的仿真过程，在虚拟空间中实现与现实高速公路的高度映射，从而反映实体高速公路的全生命周期过程。</span>
            <div class="btn" @click="detail2()">
              查看详情
            </div>
          </div>
        </div>
        <div class="screen">
          <div class="left">
            <img src="./images/screen3.png">
          </div>
          <div class="right">
            <span
              style="display:block;font-size: 22px;font-weight: bold;text-align: left;line-height: 40px;">智慧校园</span>
            <span
              style="display:block;font-weight: bold;text-align: left;line-height: 40px;font-size: 18px;color: #999;">河北某高校</span>
            <span
              style="display:block;font-weight: normal;text-align: left;color: #666;line-height: 24px;">通过在校园内部署大量的传感器和智能设备，实现对校园环境、教学设施、学生活动等信息的实时感知和数据采集，为智慧校园的运行提供基础数据支持。应用于智能教学辅助、智能安防、智能客服等领域，实现教学过程的智能化、校园安全的高效保障以及服务的个性化和便捷化。涵盖学校的行政管理、教学管理、师资管理、学生管理等各个方面，实现校务工作的信息化、自动化和规范化，提高管理效率和决策水平。</span>
            <div class="btn" ref="section4" @click="detail3()">
              查看详情
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact">
      <div class="center">
        <div class="title">联系我们</div>
        <div class="table">
          <el-form ref="form" :model="form" label-width="450px">
            <el-form-item>
              <span slot="label">
                <span style="color: #000;">姓名</span>
              </span>
              <el-input placeholder="请输入姓名" v-model="form.name" style="width: 300px;float: left;"></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <span style="color: #000;font-size: 16px;">电话</span>
              </span>
              <el-input placeholder="请输入电话" v-model="form.num" style="width: 300px;float: left;"></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <span style="color: #000;font-size: 16px;">邮箱</span>
              </span>
              <el-input placeholder="请输入邮箱" v-model="form.mail" style="width: 300px;float: left;"></el-input>
            </el-form-item>
          </el-form>
          <div class="btn">
            提交
          </div>
        </div>
      </div>
    </div>
    <div class="footer" ref="section5">
      <div class="center">
        <div class="left">
          <img src="./images/zbys.png">
          <span style="font-size: 22px;font-weight: bold;margin-bottom: 20px;">北京智步云上科技有限公司</span>
          <span>电话：130-5185-0850</span>
          <span>地址：北京市昌平区北清路1号院8号楼21层1单元2107</span>
        </div>
        <div class="right">
          <img src="./images/erweima.png">
          <span>扫码了解更多</span>
        </div>
        <div class="bottom">北京智步云上科技有限公司 备案/许可证编号：京ICP备2024066658号</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      form: {
        name: '',
        num: '',
        mail: '',
      }
    };
  },
  methods: {
    scrollToSection(sectionName) {
      const element = this.$refs[sectionName];
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth', // 平滑滚动效果
          block: 'start' // 滚动到元素顶部
        });
      }
    },
    trial1() {
      window.open('http://tools.swocs.com.cn/', '_blank');
    },
    trial2() {
      window.open('http://175.27.191.97:803/', '_blank');
    },
    trial3() {
      window.open('http://tools.swocs.com.cn/', '_blank');
    },
    trial4() {
      window.open('http://tools.swocs.com.cn/', '_blank');
    },
    detail1() {
      window.open('http://swocs.com.cn/index.php/jiejuefangan/13.html', '_blank');
    },
    detail2() {
      window.open('http://swocs.com.cn/index.php/jiejuefangan/15.html', '_blank');
    },
    detail3() {
      window.open('http://swocs.com.cn/index.php/jiejuefangan/16.html', '_blank');
    }
  },

};
</script>

<style lang="less" scoped>
.main {
  width: 100%;

  a {
    text-decoration: none;
    /* 去除下划线 */
    color: inherit;
    /* 让链接颜色继承父元素文本颜色，一般为黑色或默认文本颜色 */
    background-color: transparent;
    /* 背景透明 */
    border: none;
    /* 无边框 */
    outline: none;
    /* 移除聚焦时的轮廓 */
  }

  .nav {
    width: 100%;
    height: 70px;
    background: rgba(0, 0, 0, 0.9);
    position: fixed;
    z-index: 999;

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;

      img {
        display: block;
        float: left;
        vertical-align: middle;
        margin-top: 15px;
      }

      ul {
        height: 100%;
        list-style: none;
        width: 600px;
        margin: 0 auto;

        li {
          text-decoration-style: none;
          float: left;
          width: 100px;
          height: 100%;
          color: #fff;
          line-height: 70px;
          text-align: center;
          transition: background 0.3s ease, color 0.3s ease;
        }

        li:hover {
          background: #f0404a;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }

  .banner {
    width: 100%;
    height: 500px;
    padding-top: 70px;

    img {
      width: 100%;
      height: 500px;
      display: block;
      float: left;
    }

    .right {
      width: calc(100% - 1039px);
      height: 625px;
      float: left;
      padding: 120px 0 0 30px;

      span {
        display: block;
        color: #374a85;
        line-height: 80px;
      }

      .btn {
        width: 201px;
        height: 56px;
        font-size: 22px;
        color: #fff;
        letter-spacing: 2px;
        margin-top: 30px;
        border-radius: 25px;
        text-align: center;
        line-height: 56px;
        background: url("./images/Path.png") no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }

  .solve {
    padding: 50px 0;

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      text-align: center;

      .title {
        color: #000;
        font-size: 32px;
        font-weight: bold;
        margin: 50px 0;
        position: relative;
      }

      .title::after {
        content: '';
        width: 55px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        /* 定位在文字下方 */
        height: 1px;
        /* 线的高度 */
        background-color: #000;
        margin: 0 auto;
        /* 线的颜色 */
      }

      .article {
        width: 906px;
        height: 350px;
        margin: 0 auto;
      }

      .square1,
      .square2,
      .square3 {
        width: 280px;
        height: 350px;
        margin: 0 11px;
        float: left;
        transition: box-shadow 0.3s ease, color 0.3s ease;
        padding: 30px;
        border: 1px solid #eeeeee;

        img {
          width: 77px;
          height: 77px;
          margin-bottom: 24px;
        }

        .squareTitle {
          font-size: 18px;
          font-weight: bold;
          color: #000;
          margin-bottom: 24px;
        }

        .content {
          color: #666;
          font-size: 14px;
          line-height: 20px;
          text-align: left;
        }
      }

      .square1:hover,
      .square2:hover,
      .square3:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }



      .square1:hover .logo1 {
        content: url('./images/logo1-1.png');
      }

      .square2:hover .logo2 {
        content: url('./images/logo2-1.png');
      }

      .square3:hover .logo3 {
        content: url('./images/logo3-1.png');
      }
    }
  }

  .ability {
    padding: 50px 0;
    background: #fafafa;

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      text-align: center;

      .title {
        font-size: 28px;
        color: #fd505b;
      }

      .English {
        font-size: 44px;
        color: #000;
        position: relative;
        margin: 10px 0 100px;
      }

      .English::after {
        content: '';
        width: 55px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        /* 定位在文字下方 */
        height: 1px;
        /* 线的高度 */
        background-color: #000;
        margin: 0 auto;
        /* 线的颜色 */
      }

      .article:last-child {
        margin-bottom: 0px;
      }

      .article {
        width: 100%;
        height: 351px;
        margin-bottom: 100px;

        .left {
          width: 554px;
          height: 351px;
          float: left;
          background: #0069aa;
        }

        .right {
          width: calc(100% - 554px);
          height: 351px;
          float: left;
          padding: 35px 100px;
          background: transparent;

          .title {
            font-size: 28px;
            font-weight: bold;
            color: #000;
            text-align: left;
            margin-bottom: 30px;
          }

          .content {
            text-align: left;
            line-height: 36px;
          }
        }

        .case {
          width: 580px;
          height: 100%;
          float: left;

          .btn {
            width: 150px;
            height: 45px;
            font-size: 18px;
            line-height: 45px;
            background: #fd505b;
            color: #fff;
            text-align: center;
            font-weight: bold;
            border-radius: 5px;
            margin-top: 20px;
            cursor: pointer;
            transition: background 0.3s ease;
          }

          .btn:hover {
            background: #FF3333;
          }

          .btn:active {
            background: #CC3333;
          }
        }
      }
    }
  }

  .business {
    padding: 50px 0;

    .center {
      width: 1200px;
      margin: 0 auto;
      text-align: center;
      position: relative;

      .title {
        font-size: 28px;
        color: #fd505b;
      }

      .English {
        font-size: 44px;
        color: #000;
        position: relative;
        margin: 10px 0 100px;
      }

      .English::after {
        content: '';
        width: 55px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        /* 定位在文字下方 */
        height: 1px;
        /* 线的高度 */
        background-color: #000;
        margin: 0 auto;
        /* 线的颜色 */
      }

      .article {
        width: 100%;
        height: 450px;

        .case {
          width: 580px;
          height: 100%;
          float: left;

          .btn {
            width: 150px;
            height: 45px;
            font-size: 18px;
            line-height: 45px;
            background: #fd505b;
            color: #fff;
            text-align: center;
            font-weight: bold;
            border-radius: 5px;
            margin-top: 20px;
            cursor: pointer;
            transition: background 0.3s ease;
          }

          .btn:hover {
            background: #FF3333;
          }

          .btn:active {
            background: #CC3333;
          }
        }
      }

      .square {
        width: 380px;
        height: 400px;
        float: left;
        margin: 0 10px;
        padding: 50px 30px 70px;
        transition: box-shadow 0.5s ease;
        border-radius: 10px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

        .title {
          color: #fd505b;
          font-size: 22px;
          transition: color 0.5s ease;
        }

        .content {
          text-align: left;
          line-height: 36px;
          margin-top: 30px;
          color: #000;
          transition: color 0.3s ease;

        }
      }

      .square:hover {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
        background: #fd505b;
        cursor: pointer;
      }

      .square:hover .title {
        color: #fff;
      }

      .square:hover .content {
        color: #fff;
      }




      // .logoGroup {
      //   position: absolute;
      //   top: 350px;
      //   left: 0;
      //   bottom: 0;
      //   right: 0;
      //   margin: 0 auto;
      // }

    }
  }

  .partner {
    padding: 50px 0 100px;
    background: url("./images/background.png");
    background-position: center -50px;

    .center {
      width: 1410px;
      height: 100%;
      margin: 0 auto;
      text-align: center;


      .title {
        font-size: 28px !important;
        font-weight: normal !important;
        color: #fff;
        border-bottom: none !important;
      }

      .English {
        font-size: 44px;
        color: #fff;
        position: relative;
        margin: 10px 0 100px;
      }

      .English::after {
        content: '';
        width: 55px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        /* 定位在文字下方 */
        height: 1px;
        /* 线的高度 */
        background-color: #fff;
        margin: 0 auto;
        /* 线的颜色 */
      }

      .article {
        width: 100%;
        height: 470px;
      }

      .square {
        width: 470px;
        height: 470px;
        float: left;
        padding: 30px 70px 70px;
        transition: box-shadow 0.3s ease, color 0.3s ease, background 1s ease;
        border-radius: 50%;

        img {
          display: block;
          margin: 0 auto;
        }

        .squareTitle {
          display: inline-block;
          font-size: 22px;
          font-weight: bold;
          line-height: 40px;
          color: #fff;
          margin: 20px 0 10px;
        }

        .content {
          text-align: left;
          line-height: 32px;
          color: #fff;
        }
      }

      .square:hover {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.05);
        cursor: pointer;
      }




    }
  }

  .show {

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;

      .title {
        color: #000;
        font-size: 32px;
        font-weight: bold;
        margin: 50px 0;
        position: relative;
        text-align: center;
      }

      .title::after {
        content: '';
        width: 55px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        /* 定位在文字下方 */
        height: 1px;
        /* 线的高度 */
        background-color: #000;
        margin: 0 auto;
        /* 线的颜色 */
      }

      .screen {
        width: 1200px;
        height: 320px;
        padding: 30px 0;

        .left {
          width: 420px;
          height: 260px;
          float: left;
          background: transparent;

          img {
            width: 100%;
            height: 100%;
            border-radius: 10px;
          }
        }

        .right {
          width: 780px;
          float: left;
          padding: 0 20px;

          .btn {
            width: 150px;
            height: 45px;
            font-size: 18px;
            line-height: 45px;
            float: right;
            background: #fd505b;
            color: #fff;
            text-align: center;
            font-weight: bold;
            border-radius: 5px;
            cursor: pointer;
            transition: background 0.3s ease;
          }

          .btn:hover {
            background: #FF3333;
          }

          .btn:active {
            background: #CC3333;
          }
        }
      }
    }
  }

  .contact {

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;

      .title {
        color: #000;
        font-size: 32px;
        font-weight: bold;
        margin: 50px 0;
        position: relative;
        text-align: center;
      }

      .title::after {
        content: '';
        width: 55px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        /* 定位在文字下方 */
        height: 1px;
        /* 线的高度 */
        background-color: #000;
        margin: 0 auto;
        /* 线的颜色 */
      }

      .table {
        width: 100%;
        height: 450px;
        padding-top: 50px;

        .btn {
          width: 300px;
          height: 50px;
          background: #fd505b;
          margin: 0 auto;
          line-height: 50px;
          color: #fff;
          font-size: 22px;
          letter-spacing: 5px;
          border-radius: 5px;
          text-align: center;
          cursor: pointer;
        }

        .btn:hover {
          background: #FF3333;
        }

        .btn:active {
          background: #CC3333;
        }
      }
    }
  }

  .footer {
    height: 500px;
    width: 100%;
    background: #161f24;
    float: left;

    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      padding: 0;

      .left {
        height: 400px;
        float: left;
        padding: 50px 0;
        background: transparent;

        img {
          display: block;
          margin-bottom: 50px;
        }

        span {
          line-height: 30px;
          color: #fff;
          display: block;
        }
      }

      .right {
        height: 400px;
        float: right;
        padding: 50px 0;
        background: transparent;

        img {
          width: 200px;
          height: 200px;
          display: block;
          margin-bottom: 20px;
        }

        span {
          margin-left: 45px;
          color: #fff;
          font-size: 18px;
          font-weight: bold;
        }
      }

      .bottom {
        width: 100%;
        height: 100px;
        float: left;
        text-align: center;
        color: #666;
        line-height: 100px;
      }
    }

  }
}
</style>